// startup
// Load entry module and return exports
// This entry module depends on other loaded chunks and execution need to be delayed
var __webpack_exports__ = __webpack_require__.O(undefined, ["vendor-node_modules_babel_runtime-corejs3_core-js-stable_instance_concat_js-node_modules_babe-2881fa"], function() { return __webpack_require__(9874); })
__webpack_exports__ = __webpack_require__.O(__webpack_exports__);
